import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './components/MobileResponsive.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './pages/About';
import FAQ from './components/FAQ';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Dashboard from './components/Dashboard';
import Terms from './components/Terms';
import Teams from './pages/Teams';
import Privacy from './components/Privacy';
import styled from 'styled-components';
import ScrollToTop from './components/ScrollToTop';
import EmailVerification from './components/EmailVerification';
import PlanSuccess from './components/PlanSuccess';
import PlanFailure from './components/PlanFailure';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
  margin-top: 80px; // Account for fixed header
`;

function App() {
  return (
    <Router>
      <AppContainer>
        <Header />
        <MainContent>
        <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/verify-email" element={<EmailVerification />} />
            <Route path="/plan-success" element={<PlanSuccess />} />
            <Route path="/plan-failure" element={<PlanFailure />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </MainContent>
        
      </AppContainer>
    </Router>
  );
}

export default App;
